import HTTP from "@/_helpers/http";
import { PROFILE__API } from "@/_helpers/urls";
import { PROFILE__MUTATIONS } from "../mutation-types";
import { PROFILE__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

const state = {
  live_trades: null,
  total: 0,
};

const getters = {};

const mutations = {
  [PROFILE__MUTATIONS.LIVETRADES](state, data) {
    state.live_trades = data;
  },

  [PROFILE__MUTATIONS.TOTALLIVETRADES](state, data) {
    state.total = data;
  },
};

const actions = {
  async [PROFILE__ACTIONS.LIVETRADES]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(PROFILE__API.LIVETRADES);
      commit(PROFILE__MUTATIONS.LIVETRADES, response.data.live_trades);
      commit(PROFILE__MUTATIONS.TOTALLIVETRADES, response.data.total);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: true,
  state,
  getters,
  actions,
  mutations,
};
